<template>
  <div>
    <SampleSearchForm :listForm="searchList" @handlerSearch="onSearch" @clear-search="clearSearch" />
    <div class="cml-button-group">
      <el-button
        type="primary"
        @click="addBtn"
        v-hasPermission="'outside-warehouse-manage/outside-application-create'"
      >新增</el-button>
      <el-button type="primary"
        @click="submitBtn"
        :disabled="selectData.length < 1"
        v-hasPermission="'outside-warehouse-manage/outside-application-create'"
      >批量提交</el-button>
      <el-button
        type="primary"
        @click="exportBtn"
        v-hasPermission="'outside-warehouse-manage/outside-application-create'"
      >导入</el-button>
    </div>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParam"
      @page-size-change="pageSizeChange"
      @sort-change="sortChange"
       @select-change="(arr) => {this.selectData = arr;}"
    >
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="toUpdate(row, 'detail')">{{
          row.code
        }}</span>
      </template>
      <!-- 采用结果 -->
      <template #isUseSlot="{ row }">
        <div>
          <span>
            {{ row.isUse ? (row.isUse === 'YES' ? '采用' : '不采用') : '' }}
          </span>
          <el-tooltip
            v-if="row.reason"
            effect="dark"
            :content="row.reason"
            placement="top"
          >
            <span class="sample-btn">查看原因</span>
          </el-tooltip>
        </div>
      </template>
      <!-- 状态 -->
      <template #statusSlot="{ row }">
        <div>
          <span>{{ row.statusName }}</span>
          <el-tooltip
            style="margin-left: 10px"
            v-if="row.checkRemark"
            effect="dark"
            :content="row.checkRemark"
            placement="top"
          >
            <span class="sample-btn">查看原因</span>
          </el-tooltip>
          <el-button
            style="margin-left: 10px"
            type="text"
            v-if="['REJECT', 'LEADER_REJECT', 'SAVE'].includes(row.status) && row.createBy === userInfo.id"
            @click="toUpdate(row, 'update')"
            v-hasPermission="'outside-warehouse-manage/outside-application-update'"
            >修改</el-button
          >
        </div>
      </template>
      <!-- 明细状态 -->
      <template #detailSlot="{ row }">
        <div>
          <span>{{ row.detailStatusName }}</span>
          <el-button
            v-if="row.detailId"
            style="margin-left: 10px"
            type="text"
            @click="ckeckDetail(row)"
            >查看明细</el-button
          >
        </div>
      </template>
    </CommonTable>
    <!-- 修改，详情弹框 -->
    <el-dialog :visible.sync="dialogVisible" center top="5vh" width="1200px" :close-on-click-modal="false"  :close-on-press-escape="false">
      <OutsideApplySample
        v-if="dialogVisible && status === 'update'"
        ref="outsideApplySample"
        :status="status"
        @on-success="getList"
        @cancel-btn="dialogVisible = false"
      />
      <OutsideSample v-if="dialogVisible && status === 'detail'" :id="id" :detailId="detailId" />
      <div v-if="status === 'detail'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <Import ref="importDialog" @refresh="onSearch"/>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import OutsideApplySample from '@/components/OutsideApplySample';
import OutsideSample from '@/components/OutsideSample';
import Import from './Import'
import dayjs from 'dayjs';
export default {
  components: { CommonTable, SampleSearchForm, OutsideApplySample, OutsideSample, Import },
  props: {
    operateBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
          {
            tag: 'DictSelect',
            label: '状态',
            type: 'cml_oorder_status',
            prop: 'status',
            defaultValue: undefined,
            placeholder: '请选择状态',
          },
          {
            tag: 'DictSelect',
            type: 'cml_oorder_detail_status',
            label: '明细状态',
            prop: 'detailStatus',
            defaultValue: undefined,
            placeholder: '请选择状态',
          },
          {
            tag: 'el-input',
            label: '快递单号',
            prop: 'expressNo',
            defaultValue: undefined,
            placeholder: '请输入完整的快递单号',
          },
          {
            tag: 'el-date-picker',
            type: 'datetime',
            label: '申请开始时间',
            prop: 'createDate',
            defaultValue: undefined,
            placeholder: '请选择时间',
          },
          {
            tag: 'el-date-picker',
            type: 'datetime',
            label: '申请结束时间',
            prop: 'createdDateEnd',
            defaultValue: undefined,
            placeholder: '请选择时间',
          },
        ],
      },
      listForm: {},
      tableLoading: false,
      tableParam: {
        pageNo: 1,
        pageSize: 20
      },
      tableHeadTab: [
        { label: '产品名称', prop: 'productName', sortable: true },
        {
          label: '寻样单编号',
          prop: 'code',
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', sortable: true },
        { label: '数量', prop: 'num' },
        { label: '单位', prop: 'unit' },
        { label: '样品类型', prop: 'productTypeName', sortable: true },
        {
          label: '状态',
          prop: 'statusName',
          slotColumn: true,
          slotName: 'statusSlot',
          width: 150,
          sortable: true
        },
        { label: '供应商', prop: 'supplierName', sortable: true },
        {
          label: '明细状态',
          prop: 'detailStatusName',
          slotColumn: true,
          slotName: 'detailSlot',
          width: 150,
        },
        { label: '快递单号', prop: 'expressNo' },
        {
          label: '采用结果',
          prop: 'isUse',
          slotColumn: true,
          slotName: 'isUseSlot',
          sortable: true
        },
      ],
      tableDataTab: {},
      userInfo: {},
      dialogVisible: false,
      status: '',
      id: '',
      detailId: '',
      selectData: []
    };
  },
  mounted() {
    this.getList();
    this.userInfo = this.$store.getters.userSelf.user;
    this.$refs.CommonTable.changeHeight(10);
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParam.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParam,
        data: this.listForm,
      };
      if(params.data.createDate && params.data.createdDateEnd && dayjs(params.data.createDate).diff(dayjs(params.data.createdDateEnd)) > 0) {
        this.$message.error('申请开始时间不能晚于申请结束时间');
        return;
      }
      this.tableLoading = true;
      this.$http.outsideSampleManage
        .getMyOrderList(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectData = []
          this.$refs.CommonTable.clearCheckboxRow()
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
    addBtn(row) {
      this.$http.sample.orderCanCreate().then(res => {
        if (res.data && res.data === true) {
          const sampleData = {
            supplierName: row.supplierName,
            list: [row],
          };
          this.operateBtn('bill', sampleData);
        } else {
          this.$message.error('存在超过30天未反馈的样品申请，请先完成样品反馈再发起寻样申请');
        }
      }).catch((err) => {
        this.$message.error(err.msg);
      })
    },
    // 修改
    toUpdate(row, status) {
      this.status = status;
      this.id = row.id;
      this.detailId = '';
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    },
    ckeckDetail(row) {
      this.status = 'detail';
      this.id = row.id;
      this.detailId = row.detailId;
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    },
    clearSearch() {
      this.$refs.CommonTable.clearSort();
      this.tableParam.orderBy = '';
      this.tableParam.data = {};
      this.listForm = {};
      this.getList();
    },
    sortChange (val) {
      const sortList = {
        productName: 'a.product_name',
        createDate: 'a.create_date',
        productTypeName: 'a.product_type',
        statusName: 'a.status',
        supplierName: 'b.supplier_name',
        isUse: 'b.is_use',
      }
      const str = val.split(' ');
      this.tableParam.orderBy = sortList[str[0]] ? sortList[str[0]] + ' ' + str[1] : val;
      this.getList();
    },
    // 批量提交
    submitBtn() {
      this.$confirm('是否确认提交?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            const isStatus = this.selectData.every(item => {
              return item.status === 'SAVE'
            })
            if(!isStatus) {
              this.$message.error('只能提交【新建】状态的单据！')
              return false
            }
           const ids = this.selectData.map(item => {return item.id})
            this.$http.outsideSampleManage.batchSubmit(ids).then(res => {
              this.$message.success(res.msg)
              this.getList();
            }).catch(err => {
              this.$message.error(err.msg)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })        
        })
    },
    // 导入
    exportBtn() {
      this.$refs.importDialog.importDialog = true;
    }
  },
};
</script>

<style lang="less" scoped>
.sample-btn {
  cursor: pointer;
  color: #AB0033;
  margin: 0 5px;
}
</style>